<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card>
      <q-form @submit.prevent="add">
        <q-card-section>
          <div class="text-h6">
            {{ parentProjectType ? `Новая подкатегория для ${parentProjectType.name}` : 'Новая категория' }}
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input dense v-model="newProjectType.name" label="Имя категории"/>
          <q-input dense v-model="newProjectType.description" type="textarea" label="Описание"/>
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn no-caps flat label="Отмена" color="negative" @click="onDialogCancel()"/>
          <q-btn no-caps flat label="Добавить" @click="" type="submit"/>
        </q-card-actions>
      </q-form>

    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import {useProjectTypesStore} from "../store/projectTypes";
import {reactive} from "vue";
import {NewProjectType, ProjectType} from "../models/project";
import {useDialogPluginComponent} from "quasar";

const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()
defineEmits([...useDialogPluginComponent.emits]);
const props = defineProps<{
  organization?: number
  parentProjectType?: ProjectType
}>()

const store = useProjectTypesStore()

const newProjectType: NewProjectType = reactive({
  name: "",
  description: "",
  organizationId: props.organization ?? null,
  parentId: props.parentProjectType?.id ?? null,
})

async function add() {
  await store.add(newProjectType)
  onDialogOK()
}
</script>

<style scoped></style>